import { Injectable, signal } from '@angular/core';
import { ToastInfo } from '../models/toast-info.model';

const DEFAULT_DELAY = 5000;

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<ToastInfo[]>([]);

  show(toast: ToastInfo): void {
    this.toasts.update((toasts) => [...toasts, { delay: DEFAULT_DELAY, ...toast }]);
  }

  success(body: string, header = 'Éxito'): void {
    this.show({ header, body, classname: 'ks-toast--success' });
  }

  error(body: string, header = 'Error'): void {
    this.show({ header, body, classname: 'ks-toast--error' });
  }

  warning(body: string, header = 'Atención'): void {
    this.show({ header, body, classname: 'ks-toast--warning' });
  }

  info(body: string, header = 'Información'): void {
    this.show({ header, body, classname: 'ks-toast--info' });
  }

  remove(toast: ToastInfo): void {
    this.toasts.update((toasts) => toasts.filter((item) => item !== toast));
  }

  clear(): void {
    this.toasts.set([]);
  }
}
